/**
 *
 * Asynchronously loads the component for AdminDeleteBadge
 *
 */

import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'ui/common/loading';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading />,
});



// WEBPACK FOOTER //
// ./src/ui/companies/edit/loadable.js